module.exports = __webpack_public_path__ + "static/media/icon_orange_checklist.ac90b128.svg";